module.exports = __webpack_public_path__ + "img/dep_personalcare@3x.4ce4b255.png";